import React, {
  createContext, useCallback, useContext, useEffect, useMemo, useState,
} from 'react';
import {useLocation} from "react-router-dom";
import PropTypes from 'prop-types';

export const SearchContext = createContext({
  title: null,
  page: 1,
});

export const useSearchPage = () => useContext(SearchContext);
const Provider = ({ children }) => {
  const Location = useLocation();
  const [title, setTitle] = useState('Loja');
  const [filter, setFilter] = useState(null);
  const [filterString, setFilterString] = useState(null);
  const handleTitle = useCallback((newTitle) => {
    setTitle(newTitle);
  }, [title]);

  const handleFilterString = useCallback((fString) => {
    setFilterString(fString);
  }, [filterString]);

  const handleFilter = useCallback((f, fString) => {
    setFilter(f);
    if (fString !== null && fString !== undefined) handleFilterString(fString);
  }, [filter]);

  const value = useMemo(() => {
    return {
      title,
      filter,
      filterString,
      setTitle: handleTitle,
      setFilter: handleFilter,
      setFilterString: handleFilterString,
    };
  }, [title, filter, filterString, handleTitle, handleFilter, handleFilterString]);

  useEffect(() => {
    if (Location && !/(\/search\/)/.test(Location.pathname)) {
      setFilter(null)
    }
  }, [Location]);

  return (
    <SearchContext.Provider value={value}>
      { children }
    </SearchContext.Provider>
  );
};


Provider.propTypes = {
  children: PropTypes.node
};

export default Provider;
